import { Controller, useFormContext } from "react-hook-form";
import React from "react";
import clsx from "clsx";
const TextInput = (props) => {
    const { control, formState: { errors } } = useFormContext(); // useFormContext to get the methods from parent
    return (React.createElement(Controller, { name: props.name, control: control, render: ({ field }) => {
            var _a, _b, _c, _d;
            return (React.createElement(React.Fragment, null,
                React.createElement("input", Object.assign({}, field, { value: (_a = field.value) !== null && _a !== void 0 ? _a : "", className: clsx("form-control", props.className, { "is-invalid": errors && errors[props.name] }) }, props)),
                errors[props.name] && typeof ((_b = errors[props.name]) === null || _b === void 0 ? void 0 : _b.message) === "string" && (React.createElement("span", null, (_d = (_c = errors[props.name]) === null || _c === void 0 ? void 0 : _c.message) === null || _d === void 0 ? void 0 : _d.toString()))));
        } }));
};
export default TextInput;
